var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "phaser";
import config from "@/config";
import Handlers from "@/lib/Handlers";
import SplashGame from "@/lib/SplashGame";
import GameplayPanels from "@/prefabs/scene/Gameplay/Panels";
import GameplayWorld from "@/prefabs/scene/Gameplay/World";
import UtilsScreen from "@/lib/utils/screen";
var GameplayScene = /** @class */ (function (_super) {
    __extends(GameplayScene, _super);
    function GameplayScene() {
        return _super.call(this, { key: "GameplayScene" }) || this;
    }
    GameplayScene.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.settings = { audio: true, sfx: true };
        // init handlers
        Handlers.AudioHandler.getInstance().load(this);
        Handlers.NotificationHandler.getInstance().load(this);
        Handlers.InputHandler.getInstance().load(this);
        // init game
        Handlers.GameHandler.getInstance().load(this);
        // splash handlers
        SplashGame.PauseHandler.getInstance().set(Handlers.GameHandler.getInstance(), this.settings);
        SplashGame.ResizeHandler.getInstance().onScaleResize(this, function () {
            return _this.resize();
        });
    };
    GameplayScene.prototype.preload = function () {
        // world
        this.physics.world.setBounds(0, 0, config.world.dimension.boundary.width, config.world.dimension.boundary.height);
        // handlers
        Handlers.GameHandler.getInstance().load(this).init();
    };
    GameplayScene.prototype.create = function () {
        GameplayPanels.getInstance().load(this);
        GameplayWorld.getInstance().load(this);
    };
    GameplayScene.prototype.update = function () {
        Handlers.GameHandler.getInstance().update();
    };
    GameplayScene.prototype.start_game = function () {
        var _this = this;
        Handlers.GameHandler.getInstance().start(function (remaining) {
            GameplayPanels.getInstance().onTimerUpdate(remaining);
        }, function () {
            GameplayPanels.getInstance().onGameEnd(_this.player.getValue());
        });
        GameplayPanels.getInstance().setControls(function (x, y, angle) {
            _this.player.rotate(angle);
        }, function () {
            _this.player.attack();
        });
    };
    GameplayScene.prototype.resize = function () {
        GameplayPanels.getInstance().resize();
        // players
        var _a = UtilsScreen.safe_area(this), x_min = _a.x_min, x_max = _a.x_max, y_min = _a.y_min, y_max = _a.y_max;
        var _width = x_max - x_min;
        var _height = y_max - y_min;
        __spreadArray([this.player], this.enemies, true).map(function (e) { return e.resize(_width, _height); });
    };
    return GameplayScene;
}(Phaser.Scene));
export default GameplayScene;
